"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var trmvrmeterEntryRemarkActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/remark");
require("./style.scss");
var components_1 = require("components");
var react_router_dom_1 = require("react-router-dom");
var translate_1 = require("utils/translate");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var options_1 = require("views/SokoSiteViews/TRMVRMeterRemarksView/Modal/options");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        remarks: state.trmvrmeterentries.remark.remarks,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchRemarks: function (meterUuid, entryUuid) {
        return dispatch(trmvrmeterEntryRemarkActions.fetchRequest(meterUuid, entryUuid));
    },
    fetchRemark: function (remarkUuid, meterUuid, entryUuid) {
        return dispatch(trmvrmeterEntryRemarkActions.fetchRemarkRequest(remarkUuid, meterUuid, entryUuid));
    },
    clearState: function () { return trmvrmeterEntryRemarkActions.clear(); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var createRows = function (remarks, selectedLanguage, openModal, fetchRemark, currentProject, meterUuid, entryUuid) {
    if (currentProject !== undefined &&
        meterUuid !== undefined &&
        entryUuid !== undefined) {
        var createRow_1 = function (row) {
            return (React.createElement(sok_ui_1.Row, { key: row.id },
                React.createElement(sok_ui_1.Column, null,
                    React.createElement(components_1.TableRowIcon, { icon: 'fa-solid fa-pen-square', onClick: function (e) {
                            fetchRemark(row.uuid, meterUuid, entryUuid);
                            openModal();
                        } })),
                React.createElement(sok_ui_1.Column, null, "".concat(row.target, " ").concat(row.meter_type === 'TRMETER'
                    ? (0, options_1.findNameWithId)(row.target, options_1.targetOptions)
                    : (0, options_1.findNameWithId)(row.target, options_1.targetOptionsMvr))),
                React.createElement(sok_ui_1.Column, null, "".concat(row.remark, " ").concat(row.meter_type === 'TRMETER'
                    ? (0, options_1.findRemarkWithTarget)(row.remark, row.target)
                    : (0, options_1.findRemarkWithTargetMvr)(row.remark, row.target))),
                React.createElement(sok_ui_1.Column, null,
                    React.createElement(components_1.TableRowIcon, { icon: row.confirmed_at
                            ? 'fa-solid fa-check green'
                            : 'far fa-clock orange', onClick: function (e) {
                            e.stopPropagation();
                        } }))));
        };
        return remarks.map(function (i) {
            return createRow_1(i);
        });
    }
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchRemarks(this.props.match.params.id, this.props.match.params.entryId);
    },
    componentWillUnmount: function () {
        this.props.clearState();
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    var bodyRows = createRows(props.remarks, props.selectedLanguage, props.openModal, props.fetchRemark, props.currentProject, props.match.params.id, props.match.params.entryId);
    return (React.createElement("div", { className: 'trmvrmeter-entry-remarks' }, props.remarks.length > 0 ? (React.createElement("div", { className: 'remarks-table' },
        React.createElement("div", { className: 'remarks-table-head' },
            React.createElement(sok_ui_1.Row, null,
                React.createElement(sok_ui_1.Column, { children: [] }),
                React.createElement(sok_ui_1.Column, null, (0, translation_1.getLocalization)('trmvrmeterEntryView/column/target')),
                React.createElement(sok_ui_1.Column, null, (0, translation_1.getLocalization)('trmvrmeterEntryView/column/remark')),
                React.createElement(sok_ui_1.Column, { children: [] }))),
        React.createElement("div", { className: 'remarks-table-body' }, bodyRows))) : (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { key: "no-remarks", title: "trmvrmeterEntryView/emptyRemarkList/title", message: "trmvrmeterEntryView/emptyRemarkList/message" }))));
});
